export default "__VITE_ASSET__DVHCTYbx__"